import type { Client, CreditMemo, Business } from '@/lib/api';
import { creditMemoApi } from '@/lib/api';
import { SendDocumentModal } from './SendDocumentModal';

interface SendCreditMemoModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  creditMemo: CreditMemo;
  client: Client | null;
  business: Business | null;
  onSend: (data: {
    to: string[];
    cc: string[];
    bcc: string[];
    subject: string;
    message: string;
    cc_self: boolean;
  }) => Promise<void>;
}

export function SendCreditMemoModal({
  open,
  onOpenChange,
  creditMemo,
  client,
  business,
  onSend,
}: SendCreditMemoModalProps) {
  return (
    <SendDocumentModal
      open={open}
      onOpenChange={onOpenChange}
      documentType="credit_memo"
      documentId={creditMemo.id}
      documentNumber={creditMemo.credit_memo_number || creditMemo.id}
      noteForClient={undefined}
      client={client}
      business={business}
      getSendTemplate={creditMemoApi.getSendTemplate}
      onSend={onSend}
    />
  );
}
